import { SnackbarTopLayer } from "@/components/app/SnackbarTopLayer";
import MuiModusSnackbar from "@/components/app/MuiModusSnackbar";
import type { NotificationsProviderSlotProps } from "@toolpad/core";
import type { ElementType } from "react";

type SnackbarConfig = {
  slot: ElementType;
  slotProps: NotificationsProviderSlotProps["snackbar"];
};

const muiSnackbarConfig: SnackbarConfig = {
  slot: SnackbarTopLayer,
  slotProps: {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    sx: {
      "& .MuiAlert-root": { alignItems: "center" },
      "& .MuiAlert-icon": {
        paddingTop: 0,
        paddingBottom: 0,
      },
      "& .MuiAlert-message": {
        paddingTop: 0,
        paddingBottom: 0,
      },
      "& .MuiAlert-action": {
        alignItems: "center",
        paddingTop: 0,
      },
    },
  },
};

const modusSnackbarConfig: SnackbarConfig = {
  slot: MuiModusSnackbar,
  slotProps: {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    sx: {
      maxWidth: {
        xs: "calc(100vw - 32px)",
        sm: "min(400px, calc(100vw - 48px))",
      },
    },
  },
};

export { modusSnackbarConfig, muiSnackbarConfig };
